<script>
import { Line, mixins } from 'vue-chartjs'

export default {
  name: 'HistoryChart',
  props: ['chartData'],
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero:true
            },
            scaleLabel: {
              display: true,
              labelString: 'Minutes'
            }
          }],
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        },
        tooltips: {
          enabled: true,
          backgroundColor: '#fff',
          bodyFontColor: '#27272C',
          bodyFontSize: 22,
          titleFontColor: 'rgba(60, 60, 67, 0.6)',
          titleFontSize: 12,
          xPadding: 20,
          yPadding: 10,
          borderColor: '#ccc',
          borderWidth: 1,
          displayColors: false,
          callbacks: {
            label: ((tooltipItems) => {
              return tooltipItems.yLabel + 'm'
            })
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    }
  },
  mixins: [mixins.reactiveProp],
  extends: Line,
  mounted() {
    this.renderChart(
        this.chartData, this.options
    );
  }
}

</script>

<style lang="scss">

</style>
